import {
  REQUEST_VEHICLES_TO_SERVICE,
  RECEIVE_VEHICLES_TO_SERVICE,
  REQUEST_TO_SERVICE_VEHICLE,
  RECEIVE_TO_SERVICE_VEHICLE,
} from '../constants';
import generateActions from './baseAction';
import API from '../api';

const {
  showError,
  clearErrors,
  getVehicles,
  getVehicle,
  addVehicle,
  updateVehicle,
  removeVehicle,
} = generateActions('vehicle', 'vehicles');

const getVehiclesToService = (page: number = 0) => async (dispatch) => {
  dispatch({
    type: REQUEST_VEHICLES_TO_SERVICE,
  });
  const response = await API.request(`/vehicles/service?offset=${page}`);
  const {
    data: { vehicles, lastPage },
  } = await response.json();
  dispatch({
    data: vehicles,
    type: RECEIVE_VEHICLES_TO_SERVICE,
  });
  return { vehicles, lastPage };
};

const getRevision = (vehicleId, revisionId) => (dispatch) => {
  return API.request(`/vehicles/${vehicleId}/revision/${revisionId}`)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

const serviceVehicle = (id: number, serviceFields: IServiceFields) => async (
  dispatch,
) => {
  dispatch({
    type: REQUEST_TO_SERVICE_VEHICLE,
  });
  const response = await API.request(
    `/vehicles/${id}/service`,
    'POST',
    serviceFields,
  );
  dispatch({
    type: RECEIVE_TO_SERVICE_VEHICLE,
  });
  return await response.json();
};

export {
  showError,
  clearErrors,
  getVehicles,
  getVehicle,
  addVehicle,
  updateVehicle,
  removeVehicle,
  getVehiclesToService,
  serviceVehicle,
  getRevision,
};
